import React from "react";
import Chapter from "@/components/landing/Chapter";
import Reveal from "@/components/landing/Reveal";

const metrics = [
  { value: "3", label: "Ediciones celebradas" },
  { value: "112", label: "Mujeres líderes participantes" },
  { value: "+10", label: "Impactos en medios" },
  { value: "65%", label: "Participantes que repiten" },
  { value: "100%", label: "Recomendarían el programa" },
];

const Authority = () => {
  return (
    <section
      id="autoridad"
      data-testid="authority-section"
      className="bg-[#63846F] text-[#FAF8F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-8 md:gap-14 items-start">
          <div className="col-span-12 lg:col-span-6">
            <Reveal>
              <Chapter number="01" label="Comunidad" tone="light" />
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#FAF8F3]">
                Lo que comenzó como un encuentro
                <span className="italic"> hoy es una comunidad.</span>
              </h2>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:pt-4 space-y-6 text-[#FAF8F3]/90 font-sans text-base md:text-lg leading-relaxed">
            <Reveal delay={120}>
              <p>
                Lidera con Voz Propia nació como una jornada presencial y se ha
                convertido en un ecosistema de transformación empresarial
                femenino que impulsa liderazgo, alianzas, visibilidad y
                crecimiento.
              </p>
            </Reveal>
            <Reveal delay={220}>
              <p>
                En sus tres primeras ediciones ha reunido a mujeres
                empresarias, directivas y profesionales con capacidad de
                decisión, generando presencia en medios, alianzas
                institucionales y una comunidad que sigue creciendo edición
                tras edición.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Metrics */}
        <div
          className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 border-t border-[#FAF8F3]/25"
          data-testid="authority-metrics"
        >
          {metrics.map((m, i) => (
            <Reveal
              key={m.label}
              delay={i * 80}
              className={`px-4 py-8 md:px-6 md:py-10 border-b md:border-b-0 border-[#FAF8F3]/25 ${
                i !== metrics.length - 1 ? "md:border-r" : ""
              } ${i % 2 === 0 ? "border-r md:border-r" : ""}`}
              data-testid={`metric-${i}`}
            >
              <div className="font-serif text-5xl md:text-6xl text-[#FAF8F3] leading-none">
                {m.value}
              </div>
              <div className="mt-4 overline text-[#FAF8F3]/75 leading-snug">
                {m.label}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Authority;
